import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'src/app/auth';

const Player = lazy(() => import('./player/Player'));
const Players = lazy(() => import('./players/Players'));
const AssignApkApp = lazy(() => import('./player/AssignApkApp'));

const PlayerGroupAppConfig = {
  settings: {
    layout: {},
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/playerGroups',
      element: <Players />,
    },
    {
      path: 'apps/playerGroups/:playerId/*',
      element: <Player />,
    },
    {
      path: 'apps/playerGroups/modifyapps/:playerId/*',
      element: <AssignApkApp />,
    }
  ],
};

export default PlayerGroupAppConfig;
